// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icons {
  margin: auto auto 2px auto;
}

.draggable {
  cursor: pointer;
}

.draggable * {
  -webkit-user-select: none;
  user-select: none;
}

.draggable_icon {
  width: 35px;
  text-align: center;
}

.active {
  display: block;
}

.inactive {
  display: none;
}

::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  color: #aaa;
}

:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: #aaa;
  opacity: 1;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #aaa;
  opacity: 1;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #aaa;
}

:-ms-input-placeholder { /* Microsoft Edge */
  color: #aaa;
}

.inputConfigs {
  border-collapse: inherit;
  padding: 5px;
  cursor: pointer;
}

.inputConfigs tr td:first-child {
  padding-right: 10px;
}

.inputConfigs tr td input[type=text] {
  padding: 3px;
}

table.inputConfigs tr td:first-child input[type=text] {
  border: 1px solid white;
}

table.inputConfigs tr td:last-child input[type=text],
table.inputConfigs tr td:last-child input[type=checkbox],
table.inputConfigs tr td:last-child textarea,
table.inputConfigs tr td:last-child select {
  background-color: #EDF2F5;
  color: #aaa;
  cursor: pointer;
}

div.draggable div.sprout:hover {
  background-color: lightgoldenrodyellow;
}

div.draggable:hover div.sprout table.inputConfigs tr td:first-child input[type=text] {
  border: 1px solid #999;
}

table.inputConfigs tr td:first-child input[type=text].borderSelected {
  border: 1px solid #999;
}

div.multiline div.sprout table.inputConfigs tr td {
  vertical-align: top;
}

.checkbox {
  margin: auto;
}

.dbTitle {
  margin: 0 0 0 5px;
  padding: 0;
  color: black;
}

.secondBags {
  width: 100%;
  min-height: 210px;
  overflow-y: visible;
}

.target {
  min-height: 100px;
  background-color: #AAA;
  overflow-y: visible;
  border: 1px solid #AAA;
  margin-bottom: 10px;
}

.dropMainWindow {
  min-height: 100px;
  overflow-y: visible;
  background-color: white;
}

.subTargets {
  min-height: 100px;
  overflow-y: visible;
  width: 50%;
}

.leftMarker {
  border-right: 1px solid #AAA;
}

.itemSelected {
  background-color: lightgoldenrodyellow;
}

.sprout {
  border-bottom: 1px dotted #9A9A9A;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/customizable-forms/components/customizable-form/customizable-form.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,yBAAA;EAGA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA,8BAAA,wBAAA;EACI,WAAA;AACJ;;AAEA,oBAAA,4BAAA;EACI,WAAA;EACA,UAAA;AACJ;;AAEA,qBAAA,wBAAA;EACI,WAAA;EACA,UAAA;AACJ;;AAEA,yBAAA,4BAAA;EACI,WAAA;AACJ;;AAEA,yBAAA,mBAAA;EACI,WAAA;AACJ;;AAEA;EACI,wBAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;;;;EAII,yBAAA;EACA,WAAA;EACA,eAAA;AACJ;;AAEA;EACI,sCAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,iBAAA;EACA,UAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,mBAAA;EACA,UAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI,sCAAA;AACJ;;AAEA;EACI,iCAAA;AACJ","sourcesContent":[".icons {\n    margin: auto auto 2px auto;\n}\n\n.draggable {\n    cursor: pointer;\n}\n\n.draggable * {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.draggable_icon {\n    width: 35px;\n    text-align: center;\n}\n\n.active {\n    display: block;\n}\n\n.inactive {\n    display: none;\n}\n\n::-webkit-input-placeholder { /* WebKit, Blink, Edge */\n    color: #aaa;\n}\n\n:-moz-placeholder { /* Mozilla Firefox 4 to 18 */\n    color: #aaa;\n    opacity: 1;\n}\n\n::-moz-placeholder { /* Mozilla Firefox 19+ */\n    color: #aaa;\n    opacity: 1;\n}\n\n:-ms-input-placeholder { /* Internet Explorer 10-11 */\n    color: #aaa;\n}\n\n:-ms-input-placeholder { /* Microsoft Edge */\n    color: #aaa;\n}\n\n.inputConfigs {\n    border-collapse: inherit;\n    padding: 5px;\n    cursor: pointer;\n}\n\n.inputConfigs tr td:first-child {\n    padding-right: 10px;\n}\n\n.inputConfigs tr td input[type=text] {\n    padding: 3px;\n}\n\ntable.inputConfigs tr td:first-child input[type=text] {\n    border: 1px solid white;\n}\n\ntable.inputConfigs tr td:last-child input[type=text],\ntable.inputConfigs tr td:last-child input[type=checkbox],\ntable.inputConfigs tr td:last-child textarea,\ntable.inputConfigs tr td:last-child select {\n    background-color: #EDF2F5;\n    color: #aaa;\n    cursor: pointer;\n}\n\ndiv.draggable div.sprout:hover {\n    background-color: lightgoldenrodyellow;\n}\n\ndiv.draggable:hover div.sprout table.inputConfigs tr td:first-child input[type=text] {\n    border: 1px solid #999;\n}\n\ntable.inputConfigs tr td:first-child input[type=text].borderSelected {\n    border: 1px solid #999;\n}\n\ndiv.multiline div.sprout table.inputConfigs tr td {\n    vertical-align: top;\n}\n\n.checkbox {\n    margin: auto;\n}\n\n.dbTitle {\n    margin: 0 0 0 5px;\n    padding: 0;\n    color: black;\n}\n\n.secondBags {\n    width: 100%;\n    min-height: 210px;\n    overflow-y: visible;\n}\n\n.target {\n    min-height: 100px;\n    background-color: #AAA;\n    overflow-y: visible;\n    border: 1px solid #AAA;\n    margin-bottom: 10px;\n}\n\n.dropMainWindow {\n    min-height: 100px;\n    overflow-y: visible;\n    background-color: white;\n}\n\n.subTargets {\n    min-height: 100px;\n    overflow-y: visible;\n    width: 50%;\n}\n\n.leftMarker {\n    border-right: 1px solid #AAA\n}\n\n.itemSelected {\n    background-color: lightgoldenrodyellow;\n}\n\n.sprout {\n    border-bottom: 1px dotted #9A9A9A;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
